import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
  ModalOptions,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { ChangeEmailService } from './../../../../../../_services/profile-settings/change-email.service';
import { Router , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from './../../../../../../_services/error-service/error-redirection.service';
import { EmailService } from './../../../../../../_services/email/email.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { UserDetailsService } from './../../../../../../_services/profile-settings/user-details.service';
import { PolicyDetailsService } from './../../../../../../_services/my-insurance/policy-details.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-review-or-update-email-modal',
  templateUrl: './review-or-update-email-modal.component.html',
  styleUrls: ['./review-or-update-email-modal.component.scss'],
})
export class ReviewOrUpdateEmailModalComponent implements OnInit {
  @Input() userDetails;
  @Input() policyEmail;
  @Input() policyId;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  whereToFindModalOptions: ModalOptions;
  uploadingFiles: ModalOptions;
  hideModalOnRoute: any = false;
  hideModal: boolean;
  emailMask: string;
  loader = false;
  isAcmic = false;
  constructor(
    private changeEmailService: ChangeEmailService,
    public router: Router,
    private errorRedirectionService: ErrorRedirectionService,
    private alertService: AlertService,
    private emailService: EmailService,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private policyService: PolicyDetailsService,
    private acmicService: AcmicService
  ) {
    this.hideModal = false;
    this.uploadingFiles = new ModalOptions({
      additionalClasses:
        'modal-medium modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'reviewOrUpdateEmailModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: '',
      modalName: 'review_or_update_email_modal',
    });
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.emailMask = this.emailService.maskEmail(this.policyEmail);
  }
  resetHideModal(event): void {
    this.hideModal = !this.hideModal;
    if (event) {
      this.closeModal.emit(true);
    }
  }
  cancel() {
    this.resetHideModal(true);
  }
  updateEmail() {
    this.loader = true;
    const reqBody = {
      email: this.policyEmail,
      password: '',
    };
    this.changeEmailService
      .updateAccountEmailDuringPolicyAdd(this.userDetails, reqBody)
      .subscribe(
        (resp) => {
          this.addPolicyToEmail(resp);
        },
        (error) => {
          this.loader = false;
          this.resetHideModal(true);
          if (error.status) {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
  }
  onServiceError(error): void {
    this.loader = false;
    this.errorRedirectionService.errorRedirectHandler(error);
  }
  reSync(email, resp): void {
    this.storageService.setUserStorage(email, resp);
    this.policyService.getPolicyDetailsByEmail(email).subscribe(
      () => {
        this.getUserDetailsWithLatestAccEmail();
      },
      (errors) => {
        this.onServiceError(errors);
      }
    );
  }
  getUserDetailsWithLatestAccEmail() {
    this.userDetailsService.getUserDetailsByEmail().subscribe(
      () => {
        this.loader = false;
        this.resetHideModal(true);
        this.alertService.success('Policy added to your account.', true);
        this.router.navigate(['/my-insurance']);
      },
      (errors) => {
        this.onServiceError(errors);
      }
    );
  }
  addPolicyToEmail(result) {
    this.policyService
      .addPolicyToEmail(this.policyEmail, this.policyId)
      .subscribe(
        () => {
          setTimeout(() => {
            this.reSync(this.policyEmail, result);
          }, 500);
        },
        (err) => {
          this.onServiceError(err);
        }
      );
  }
}
